import styled from 'styled-components';
export const CollapseContainer = styled.div `
  height: 0;
  overflow: hidden;
  transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

  &.entered {
    height: auto;
    overflow: visible;
  }

  &.exited {
    visibility: hidden;
  }
`;
export const CollapseWrapper = styled.div `
  display: flex;
`;
export const CollapseWrapperInner = styled.div `
  width: 100%;
`;
//# sourceMappingURL=styles.js.map